// extracted by mini-css-extract-plugin
export default {"error":"form_error__7BI7S"};